import * as Types from 'app/types/schema';

import gql from 'graphql-tag';
import * as Urql from 'app/libs/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AssetsTableQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ItemFilters>;
  sorts?: Types.InputMaybe<Array<Types.SortProps> | Types.SortProps>;
  limit?: Types.InputMaybe<Types.Scalars['Float']>;
  page?: Types.InputMaybe<Types.Scalars['Float']>;
  siteId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AssetsTableQuery = { __typename?: 'Query', items: { __typename?: 'ItemConnection', totalCount: number, edges: Array<{ __typename?: 'ItemEdge', node: { __typename?: 'AssetItemSchema', id: string, sku: string, title: string, mName: string, modelNumber?: string | null, serialNumber?: string | null, categoryId: string, vendorId?: string | null, brand?: string | null, description?: string | null, cost?: number | null, totalQuantity?: number | null, purchaseDate?: string | null, warrantyExpiryDate?: string | null, replacementDate?: string | null, type: Types.ItemTypeEnum, manufacturerId?: string | null, pickableThroughOrderRequest?: boolean | null, attachments?: Array<{ __typename: 'MediaSchema', size?: number | null, url?: string | null, mimeType?: string | null, kind: Types.MediaKindEnum, resolutions: Array<{ __typename: 'ResolutionType', type: Types.ResolutionEnum, url: string }> }> | null, protectedAttachments?: Array<{ __typename: 'MediaSchema', size?: number | null, url?: string | null, mimeType?: string | null, kind: Types.MediaKindEnum, resolutions: Array<{ __typename: 'ResolutionType', type: Types.ResolutionEnum, url: string }> }> | null, category?: { __typename?: 'CategorySchema', name: string, status: Types.CategoryStatusEnum } | null, vendor?: { __typename?: 'CompanySchema', id: string, companyName: string, status: Types.CompanyStatusEnum } | null, manufacturer?: { __typename?: 'ManufacturerSchema', name: string, status: string } | null, stockInformation?: Array<{ __typename?: 'ItemLocationSchema', id: string, siteId: string, outOfStockAt?: string | null, totalQuantity?: number | null, itemId: string, minimumQuantity?: number | null, maximumQuantity?: number | null, location: { __typename?: 'LocationSchema', id: string, name: string } }> | null, reminders?: Array<{ __typename?: 'AssetItemReminder', _id: string, jobId: string, type?: Types.AssetItemReminderTypeEnum | null, note: string, cron?: string | null, notifyUserIds: Array<string>, status: Types.AssetItemReminderStatusEnum, startReminderAt: string, lastReminderAt?: string | null, meta?: string | null, recurring?: boolean | null, recurringInterval?: number | null }> | null } | { __typename?: 'AssetKitItemSchema', id: string, sku: string, title: string, categoryId: string, vendorId?: string | null, brand?: string | null, description?: string | null, cost?: number | null, totalQuantity?: number | null, type: Types.ItemTypeEnum, manufacturerId?: string | null, pickableThroughOrderRequest?: boolean | null, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, kind: Types.MediaKindEnum }> | null, category?: { __typename?: 'CategorySchema', name: string, status: Types.CategoryStatusEnum } | null, vendor?: { __typename?: 'CompanySchema', id: string, companyName: string, status: Types.CompanyStatusEnum } | null, manufacturer?: { __typename?: 'ManufacturerSchema', name: string, status: string } | null, stockInformation?: Array<{ __typename?: 'ItemLocationSchema', id: string, siteId: string, outOfStockAt?: string | null, totalQuantity?: number | null, itemId: string, minimumQuantity?: number | null, maximumQuantity?: number | null, location: { __typename?: 'LocationSchema', id: string, name: string } }> | null } | { __typename?: 'AssetModelItemSchema', id: string, sku: string, title: string, categoryId: string, vendorId?: string | null, brand?: string | null, description?: string | null, cost?: number | null, type: Types.ItemTypeEnum, manufacturerId?: string | null, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, kind: Types.MediaKindEnum }> | null, category?: { __typename?: 'CategorySchema', name: string, status: Types.CategoryStatusEnum } | null, vendor?: { __typename?: 'CompanySchema', id: string, companyName: string, status: Types.CompanyStatusEnum } | null, manufacturer?: { __typename?: 'ManufacturerSchema', name: string, status: string } | null } | { __typename?: 'InventoryItemSchema' } | { __typename?: 'InventoryKitItemSchema' } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, nextCursor?: string | null, prevCursor?: string | null } | null } };


export const AssetsTableDocument = gql`
    query assetsTable($filters: ItemFilters, $sorts: [SortProps!], $limit: Float, $page: Float, $siteId: String) {
  items(filters: $filters, sorts: $sorts, limit: $limit, page: $page) {
    edges {
      node {
        ... on AssetItemSchema {
          id
          attachments {
            size
            url
            mimeType
            kind
            resolutions {
              type
              url
              __typename
            }
            __typename
          }
          protectedAttachments {
            size
            url
            mimeType
            kind
            resolutions {
              type
              url
              __typename
            }
            __typename
          }
          sku
          title
          mName
          modelNumber
          serialNumber
          categoryId
          category {
            name
            status
          }
          vendorId
          vendor {
            id
            companyName
            status
          }
          brand
          description
          cost
          totalQuantity(siteId: $siteId)
          purchaseDate
          warrantyExpiryDate
          replacementDate
          type
          manufacturerId
          manufacturer {
            name
            status
          }
          stockInformation(siteId: $siteId) {
            id
            siteId
            location {
              id
              name
            }
            outOfStockAt
            totalQuantity
            itemId
            minimumQuantity
            maximumQuantity
          }
          reminders {
            _id
            jobId
            type
            note
            cron
            notifyUserIds
            status
            startReminderAt
            lastReminderAt
            meta
            recurring
            recurringInterval
          }
          pickableThroughOrderRequest
        }
        ... on AssetKitItemSchema {
          id
          attachments {
            url
            kind
          }
          sku
          title
          categoryId
          category {
            name
            status
          }
          vendorId
          vendor {
            id
            companyName
            status
          }
          brand
          description
          cost
          totalQuantity(siteId: $siteId)
          type
          manufacturerId
          manufacturer {
            name
            status
          }
          stockInformation(siteId: $siteId) {
            id
            siteId
            location {
              id
              name
            }
            outOfStockAt
            totalQuantity
            itemId
            minimumQuantity
            maximumQuantity
          }
          pickableThroughOrderRequest
        }
        ... on AssetModelItemSchema {
          id
          attachments {
            url
            kind
          }
          sku
          title
          categoryId
          category {
            name
            status
          }
          vendorId
          vendor {
            id
            companyName
            status
          }
          brand
          description
          cost
          type
          manufacturer {
            name
            status
          }
          manufacturerId
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
    }
    totalCount
  }
}
    `;

export function useAssetsTableQuery(options?: Omit<Urql.UseQueryArgs<AssetsTableQueryVariables>, 'query'>) {
  return Urql.useQuery<AssetsTableQuery>({ query: AssetsTableDocument, ...options });
};